import script from "./Vue3Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Vue3Modal.vue?vue&type=script&setup=true&lang=ts"

import "./Vue3Modal.vue?vue&type=style&index=0&id=04d4f9e4&lang=scss&scoped=true"

import exportComponent from "../../../../contact/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d4f9e4"]])

export default __exports__